import { useMemo } from 'react';
import { Target, Source, Destination } from '../types/DataSyncItem';
import { DataSyncObjectsStore } from '../stores/object/DataSyncObjectsStore';
import { DataSyncObjectStoreFactory } from '../stores/object/DataSyncObjectStoreFactory';

/**
 * Hook for accessing DataSyncObjectsStore instances within React components
 * This abstracts away the store creation logic from components
 *
 * @param target The Target (SOURCE or DESTINATION) for which the store is created
 * @param object Optional Source or Destination object to determine the product and instance
 * @returns A DataSyncObjectsStore instance for the specified product and instance
 */
export function useDataSyncObjectStore<T extends DataSyncObjectsStore>(
  target: Target,
  object?: Source | Destination,
): T | null {
  return useMemo(() => {
    if (!object?.product) {
      return null;
    }

    return DataSyncObjectStoreFactory.createStore(object.product, target, object.instance.id) as T;
  }, [target, object]);
}
